import { map } from "lodash";
import { cn } from "@/lib/utils.ts";

export default function CalendarList({
  calendars,
  className,
}: {
  calendars: { id: string; color: string; name: string }[];
  className?: string;
}) {
  return (
    <ol className={cn("calendar-list flex flex-wrap gap-2 mb-8", className)}>
      {map(calendars, (cal) => (
        <li className="flex gap-1 items-center" key={cal.id}>
          <i
            className="w-4 h-4 block rounded-full"
            style={{ backgroundColor: `#${cal.color}` }}
          />
          {cal.name}
        </li>
      ))}
    </ol>
  );
}
